import { ComponentType, ReactNode } from 'react';
import { JSX } from 'react/jsx-runtime';

import { useAuthCache } from 'api/cache';
import { Login } from 'app/routes/lazyPages';

import IntrinsicAttributes = JSX.IntrinsicAttributes;

function onlySignedInPage<
  TProps extends IntrinsicAttributes & { children?: ReactNode },
>(Component: ComponentType<TProps>) {
  return function WrappedComponent(props: TProps) {
    const { loggedIn } = useAuthCache();

    if (!loggedIn) {
      return <Login />;
    }

    return <Component {...props} />;
  };
}

export default onlySignedInPage;
